import '/assets/styles/layouts/sidemenu.scss';

// Sections
import Header from '/views/sections/header';
import Footer from '/views/sections/footer';

// Templates
import SidemenuTemplate from '/views/layouts/sidemenu/template';
import classNames from 'classnames';

const SidemenuLayout = ({
	children,
	pageClass,
	title,
	loading,
	menuItems,
	className,
	hideMenuItemsOnMobile,
	authorized,
}) => {
	return (
		<div
			className={classNames(
				'page',
				'layout-sidemenu',
				className,
				pageClass ? `page-${pageClass}` : null
			)}
		>
			<Header />
			<SidemenuTemplate
				loading={loading}
				authorized={authorized}
				hideMenuItemsOnMobile={hideMenuItemsOnMobile}
				menuItems={menuItems}
				title={title}
			>
				{children}
			</SidemenuTemplate>
			<Footer />
		</div>
	);
};

export default SidemenuLayout;
